import React, { FC } from 'react';
import { styled } from '../../../../styles';
import ListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const ExtraOption: FC<ListItemTextProps> = (props) => {
  return <StyledExtraItem {...props} className={`${props.className ?? ''} extra-option`} />;
};

const StyledExtraItem = styled(ListItemText)`
    font-weight: ${tokens.fontWeightMedium};
    font-size: 14px;
    height: 41px;
    width: 100%;
    cursor: pointer;
    padding: 6px 16px;
    align-content: center;

    && {
        color: ${({ theme }) => theme.tokens.colorPrimary};
    }

    &:hover {
        background-color: rgba(0, 92, 185, 0.08);
    }
`;
